
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  setup () {
    const KN_APPLICATION_LINK = process.env.VUE_APP_KN_APPLICATION_LINK
    const i18n = useI18n()
    const lang = i18n.locale

    return {
      KN_APPLICATION_LINK,
      lang,
    }
  },
})
